import React from "react";

const Minus: React.FC<{ className: string }> = ({ className }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="Minus">
        <path
          id="Vector"
          d="M3.43945 7.94849L12.4395 7.94783"
          stroke="#7F9595"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default Minus;
